export const LOGIN_HISTORY_SEARCH = "LOGIN_HISTORY_SEARCH";
export const LOGIN_HISTORY_SEARCH_RESPONSE = "LOGIN_HISTORY_SEARCH_RESPONSE";
export const LOGIN_HISTORY_FILTER_SEARCH_RESPONSE =
  "LOGIN_HISTORY_FILTER_SEARCH_RESPONSE";
export const LOGIN_HISTORY_SHOW_FILTER_SIDEPANEL =
  "LOGIN_HISTORY_SHOW_FILTER_SIDEPANEL";
